import React, { useState } from 'react';

const AvatarImage = ({ 
  src, 
  name, 
  size = 'md', 
  className = '', 
  fallbackType = 'dicebear' // 'dicebear', 'initials', or 'placeholder'
}) => {
  const [imageError, setImageError] = useState(false);
  
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12', 
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };
  
  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  const getFallbackUrl = () => {
    if (fallbackType === 'dicebear' && name) {
      return `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(name)}&backgroundColor=f97316,fb923c,fbbf24`;
    }
    return null;
  };

  const getInitials = () => {
    if (!name) return '?';
    
    // If we have a short avatar value (likely initials), use it directly
    if (src && src.length <= 3 && !src.includes('.') && !src.startsWith('http')) {
      return src.toUpperCase();
    }
    
    // Otherwise generate initials from name
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const shouldShowImage = src && !imageError;
  const fallbackUrl = getFallbackUrl();
  const shouldShowFallbackImage = !shouldShowImage && fallbackUrl && fallbackType === 'dicebear';

  return (
    <div className={`${sizeClasses[size]} rounded-full overflow-hidden bg-gray-100 dark:bg-gray-700 ${className}`}>
      {shouldShowImage ? (
        <img
          src={src}
          alt={name || 'Avatar'}
          className="w-full h-full object-cover"
          onError={handleImageError}
        />
      ) : shouldShowFallbackImage ? (
        <img
          src={fallbackUrl}
          alt={name || 'Avatar'}
          className="w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        <div className={`w-full h-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center text-white font-semibold ${textSizes[size]}`}>
          {getInitials()}
        </div>
      )}
    </div>
  );
};

export default AvatarImage;